var styles = {"popoverContentContainer":"Popover-module_popoverContentContainer__R3Ijh","contentPopover":"Popover-module_contentPopover__HwkMX","popoverContent":"Popover-module_popoverContent__ZtfVl","popoverSectionCont":"Popover-module_popoverSectionCont__SSuMG","popoverSection":"Popover-module_popoverSection__8szw1","DVPopover":"Popover-module_DVPopover__WB-2x"};

export { styles as default };
